import React from 'react'
import { hydrate, render } from 'react-dom'
import { MuiThemeProvider } from 'material-ui/styles'
import App from './components/App'
import registerServiceWorker from './registerServiceWorker'
import { BrowserRouter } from 'react-router-dom'

// material ui theme
import theme from './styles/theme'

// fonts - material ui was built with roboto in mind
// import 'typeface-roboto'

// tachyons - for atomic css
// consider using Material UI built-in typography
import 'tachyons/css/tachyons.min.css'

// some global css
import './index.css'

const rootElement = document.getElementById('root')

const ConfiguredApp = (
  <MuiThemeProvider theme={theme}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </MuiThemeProvider>
)

// hydrate if pre-rendereed app gest loaded first
if (rootElement.hasChildNodes()) {
  hydrate(ConfiguredApp, rootElement);
} else {
  render(ConfiguredApp, rootElement)
}

registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js